import { createDraftSafeSelector, createSlice } from '@reduxjs/toolkit'
import { GlobalState } from '@store'
import { LoadingState } from '@types'

interface verifyState {
  loadingStatus: LoadingState
  message: string
}

const initialState: verifyState = {
  loadingStatus: 'NOT_STARTED',
  message: ''
}

const verifySlice = createSlice({
  name: 'verify',
  initialState,

  reducers: {
    verify: state => {
      return {
        ...state,
        loadingStatus: 'LOADING'
      }
    },
    verifySuccess: (state, action) => {
      return {
        ...state,
        tree: action.payload,
        loadingStatus: 'SUCCESS'
      }
    },
    verifyFailed: (state, action) => {
      return {
        ...state,
        loadingStatus: 'FAILED',
        message: action.payload
      }
    },
    clearverify: _state => {
      return initialState
    }
  }
})

export const verifyLoader = createDraftSafeSelector(
  [(state: GlobalState) => state.verify.loadingStatus, (state: GlobalState) => state.verify.message],
  (loadingStatus, message) => {
    const isLoading = loadingStatus === 'LOADING'
    const isFailed = loadingStatus === 'FAILED'
    const isSuccess = loadingStatus === 'SUCCESS'
    return { isLoading, isFailed, isSuccess, message }
  }
)

export const { verify, verifySuccess, verifyFailed } = verifySlice.actions
export default verifySlice.reducer
